<template>
  <div>
    <b-form-group
      horizontal
      label="Search:"
      label-size="lg"
      label-for="txtSearchBox"
    >
      <b-form-input
        type="text"
        id="txtSearchBox"
        v-model="searchString"
        placeholder="Enter location name"
      ></b-form-input>
    </b-form-group>
    <div>
      <b-button size="lg" @click="submit">Submit</b-button>
    </div>
    &nbsp;
  </div>
</template>

<script>
import ajax  from "@/resources/myApi.js";

export default {
  name: "SearchBox",
  data: () => ({
    searchString: "",
    result: []
  }),
  methods: {
    async submit() {
      try {
        ajax.get(
          "locations/search/" + this.searchString
        ).then(response => { 
          this.result = response.data; 
          this.$emit("onSearch", this.result);
        } );
        
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>
